import React from 'react';
import { useTranslation } from 'react-i18next';
import './common.scss';

function ScoreToRubblesInfo() {
  const { t } = useTranslation();
  return (
    <span className="score-to-rubbles">
      {t('common.scoreToRubblesInfo')}
    </span>
  );
}

export default ScoreToRubblesInfo;
